import { useMemo } from "react";
import { Icon } from "Components";
import Icons from "Components/Icon/Icons";
import { InfoTooltip } from "Pages/Dashboard/components";
import { GET_COLOR_BY_SCORE } from "../CampaignReport.constant";


const FlexReportCard = ({ label, score, desc, iconType, isPassCard, toolTipText }: { label: string, score: number, desc: string, iconType: keyof typeof Icons, isPassCard: boolean, toolTipText: string }) => {

    const { labelColor, cardBg, tag } = useMemo(() => {
        const { color, bg, tag } = GET_COLOR_BY_SCORE(score);
        return { labelColor: color, cardBg: bg, tag }
    }, [score]);

    const icon = isPassCard ? tag === "Fair" ? "submittedDataFair" : tag === "Poor" ? "submittedDataPoor" : iconType : iconType;

    return <div className="card" style={{ border: `1px solid ${isPassCard ? labelColor : "#eaeaeb"}` }}>
        <div className="card-content">
            <Icon type={icon} style={{ background: isPassCard ? cardBg : "#EAEAEB" }} />
            <div className="label">{label}</div>
            <div className="score" style={{ color: isPassCard ? labelColor : "black" }}>{`${score}${isPassCard ? "%" : ""}`}</div>
            <div className="description" style={{ color: isPassCard ? labelColor : "#636766" }}>{isPassCard ? `${tag} - ${desc}` : desc}</div>
        </div>
        <InfoTooltip className="tooltip" title={toolTipText}>
            <Icon type="infoTooltip" />
        </InfoTooltip>
    </div>
}

export default FlexReportCard;